
import { BIcon, BIconChatTextFill } from 'bootstrap-vue';
import { numberWithPoint } from "@/utils/helper";
import moment from 'moment';

export default {
  components: {
    BIcon,
    BIconChatTextFill,
  },
  props: {
    img: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      default: moment(Date()).format('DD MMM YYYY'),
    },
    categoryName: {
      type: String,
      default: '',
    },
    views: {
      type: [String, Number],
      default: 0
    },
    commentsCount: {
      type: Number,
      default: 0
    },
    redirectPage: {
      type: String,
      default: "",
    },
    speakers: {
      type: String,
      default: '',
    },
  },
  computed: {
    formatView() {
      return numberWithPoint(this.views);
    },
    formatDate() {
      return moment(this.date).format('DD MMM YYYY');
    },
  }
}
